<template>
    <div>
        <b-button-group class="initials">
            <b-button
                v-for="char in initials"
                :key="char"
                :pressed="char === activeInitial"
                @click="changeInitial(char)"
                :disabled="isLoading"
            >
                {{ char }}
            </b-button>
        </b-button-group>

        <loader v-if="isLoading" />
        <div v-else>
            <p v-if="errorMessage !== ''">{{ errorMessage }}</p>
            <div v-else class="list">
                <b-row>
                    <b-col cols="3">
                        <b>Name:</b>
                    </b-col>
                    <b-col cols="4">
                        <b>Breed:</b>
                    </b-col>
                    <b-col>
                        <b>Sex:</b>
                    </b-col>
                    <b-col>
                        <b>Color:</b>
                    </b-col>
                    <b-col>
                        <b>Status:</b>
                    </b-col>
                </b-row>

                <div v-if="list.length > 0">
                    <b-row
                        v-for="record in list"
                        :key="record.patient_id"
                        class="row-record"
                    >
                        <b-col cols="3">
                            <router-link
                                v-if="isUsingViewProfile"
                                :to="`/patient/profile/${record.encoded_id}`"
                            >
                                {{ record.patient_name }}
                                {{ record.primary_owner }}
                            </router-link>
                            <a
                                v-else
                                :href="
                                    CIAPPS +
                                    'patient/patient/view/' +
                                    record.encoded_id
                                "
                            >
                                {{ record.patient_name }}
                                {{ record.primary_owner }}
                            </a>
                        </b-col>
                        <b-col cols="4">
                            {{ getEntityBreed(record) }}
                        </b-col>
                        <b-col>
                            {{ record.sex }}
                        </b-col>
                        <b-col>
                            {{ record.color }}
                        </b-col>
                        <b-col>
                            {{ record.status }}
                            <span
                                v-if="record.status != 'Active'"
                                class="text-nowrap"
                            >
                                ({{ _setDateDisplay(record.status_date) }})
                            </span>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-row class="row-record">
                        <b-col>
                            <i>No records available.</i>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-pagination
                v-if="meta"
                v-show="meta.lastPage > 1"
                class="vet-pagination"
                align="right"
                v-model="meta.currentPage"
                :total-rows="meta.total"
                :per-page="meta.perPage"
                prev-text="Prev"
                next-text="Next"
                :hide-goto-end-buttons="true"
                @change="changePage"
            />
            <div></div>
        </div>
    </div>
</template>

<script>
const mapFilterCode = {
    ALL: 0,
    ACTIVE: 1,
    INACTIVE: 2,
    DECEASED: 3
};

export default {
    components: {
        Loader: () => import("@/components/elements/loader-list")
    },
    props: {
        filter: {
            type: String,
            required: true
        },
        isUsingViewProfile: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            initials: ["#", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"], // prettier-ignore
            activeInitial: "A",
            isLoading: true,
            errorMessage: "",
            list: [],
            CIAPPS: process.env.CI_APPS,
            meta: null
        };
    },
    watch: {
        filter() {
            this.changeInitial("A"); // whenever filter type (ie All, Active, etc) changes, reset initial to "A"
        }
    },
    mounted() {
        this.fetchList(1, {
            initial: this.activeInitial,
            filterType: this.filter
        });
    },
    beforeDestroy() {
        this.list = [];
    },
    methods: {
        changePage(page) {
            this.fetchList(page, {
                initial: this.activeInitial,
                filterType: this.filter
            });
        },
        async fetchList(page, { initial, filterType }) {
            this.isLoading = true;
            this.errorMessage = "";

            let params = {
                page: page ? page : 1,
                perPage: 50,
                prefix: initial,
                status: mapFilterCode[filterType]
            };

            try {
                const res = await this.$http.get(
                    process.env.BARRAMUNDI + "patient",
                    {
                        params: params
                    }
                );

                this.isLoading = false;

                if (res.data.response.message.code === 200) {
                    this.list = res.data.response.resource;
                    this.meta = res.data.response.meta;
                } else {
                    throw new Error("Unable to get patient list.");
                }
            } catch (e) {
                this.isLoading = false;
                this.errorMessage = "Error: " + e.message;
            }
        },
        changeInitial(char) {
            this.activeInitial = char;

            this.fetchList(1, {
                initial: char,
                filterType: this.filter
            });
        },
        getEntityBreed(patient) {
            var entityBreed = "";
            // --- loop each breeds
            if (
                patient.patient_breeds &&
                _.keys(patient.patient_breeds).length > 0
            ) {
                var breeds = [];
                $.each(patient.patient_breeds, function (i, v) {
                    breeds.push(v.name);
                });
                // --- append breeds to species
                if (patient.species && _.keys(patient.species).length > 0) {
                    entityBreed =
                        breeds.join(", ") + " (" + patient.species + ")";
                }
            }

            return entityBreed;
        }
    }
};
</script>

<style scoped>
.initials {
    display: block;
    margin-bottom: 20px;
}
.list {
    margin: 0 15px 10px 15px;
}
.row-record {
    padding: 7px 0;
    border-bottom: 1px solid #ddd;
}
.row-record:hover {
    background-color: #f5f5f5;
}
</style>
